import { UsersMostRecentProjectModel } from "./UsersMostRecentProject.model";

export class UsersMostRecentProject extends UsersMostRecentProjectModel {
    // Add custom methods here
}
